import { Theme, TooltipProps } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { makeStyles } from "@mui/styles";
import React from "react";

interface Props {
    title: React.ReactNode;
    placement?: TooltipProps["placement"];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: React.ReactElement<any, any>;
}

const useStyles = makeStyles((theme: Theme) => ({
    tooltip: {
        fontSize: "0.8rem",
        backgroundColor: theme.palette.primary.main,
        whiteSpace: "pre-wrap"
    },
    arrow: {
        color: theme.palette.primary.main
    }
}));

const SimpleTooltip: React.FC<Props> = props => {
    const classes = useStyles();

    return (
        <Tooltip
            arrow
            title={props.title}
            classes={{
                tooltip: classes.tooltip,
                arrow: classes.arrow
            }}
            enterDelay={500}
            placement={props.placement ?? "left"}>

            {props.children}

        </Tooltip>
    );
};

export default SimpleTooltip;
